angular.module('task-project')
    .directive('taskProjectPickerMultiple', function($filter, $document, $compile, $parse, TaskProject) {
        return {
            restrict: 'AE',
            require: '?ngModel',
            scope: {
                onChange: "&",
            },
            templateUrl: "app/task/task-project/picker-multi.html",
            link: function(scope, $element, $attrs, ngModelCtrl) {

                scope.executeOnChange = scope.onChange || angular.noop
                scope.selected = ngModelCtrl.$modelValue || [];
                scope.items = [];

                TaskProject.query().$promise.then(items => scope.items = items);

                scope.dropdownSettings = {
                    searchField: 'name',
                    enableSearch: true,
                    displayProp: 'name',
                    idProperty: 'id',
                    scrollable: true,
                    keyboardControls: true,
                    // styleActive: true
                };

                scope.dropdownMultiselectTranslations = {
                    checkAll: 'Zaznacz wszystko',
                    uncheckAll: 'Odznacz wszystko',
                    buttonDefaultText: '-- wybierz --',
                    searchPlaceholder: "szukaj..."
                };


                scope.$watchCollection(function(){ return ngModelCtrl.$modelValue; }, function(newValue, oldValue) {
                    if (oldValue != newValue){
                        //update the view value with fresh data from items, if there is a valid model value
                        if(angular.isDefined(ngModelCtrl.$modelValue)) {
                            ngModelCtrl.$modelValue = null; //Force scope model value and ngModel value to be out of sync to re-run formatters
                        }
                        scope.seleced = ngModelCtrl.$modelValue;
                    }
                });
                ngModelCtrl.$render = () => {
                    // Make sure that model value is array
                    if(!angular.isArray(ngModelCtrl.$viewValue)){
                        // Have tolerance for null or undefined values
                        if(angular.isUndefined(ngModelCtrl.$viewValue) || ngModelCtrl.$viewValue === null){
                            ngModelCtrl.$viewValue = [];
                        } else {
                            throw Exception("Expected model value to be array but got '{0}'", ngModelCtrl.$viewValue);
                        }
                    }
                    scope.selected = ngModelCtrl.$viewValue;
                };

                ngModelCtrl.$isEmpty = modelValue => !angular.isArray(modelValue) || modelValue.length === 0;

                scope.events = {
                    onSelectionChanged : () => {
                        ngModelCtrl.$setDirty();
                        ngModelCtrl.$setViewValue(scope.selected);
                        ngModelCtrl.$validate();
                        if(angular.isFunction(scope.executeOnChange())){
                            scope.executeOnChange()(scope.selected);
                        }
                    }
                }

            }
        };
    })

    // .directive('taskProjectPicker', function (TaskProject) {
    //     return {
    //         restrict: 'E',
    //         require: 'ngModel',
    //         scope: {
    //             required: "=",
    //             modelType: '=',
    //             onChange: "&",
    //             initialValue: "=?"
    //         },
    //         templateUrl: "app/task/task-project/picker.html",
    //         link: function (scope, $element, $attrs, ngModelCtrl) {
    //
    //             scope.executeOnChange = scope.onChange || angular.noop
    //             scope.modelTypeR = scope.modelType || "object"
    //
    //             TaskProject.query({ userProjectsFilter: scope.userProjectsFilter }).$promise.then(items => {
    //                 scope.items = items
    //                 if(scope.initialValue != null && typeof scope.initialValue === "string"){
    //                     scope.selected = scope.items.find(i => i.name === scope.initialValue)
    //                     scope.onSelectionChanged(scope.selected, scope.selected)
    //                 }
    //             })
    //
    //             ngModelCtrl.$render = () => scope.selected = ngModelCtrl.$viewValue
    //             ngModelCtrl.$formatters.push(modelValue => modelValue)
    //             ngModelCtrl.$parsers.push(viewValue => scope.modelTypeR === "id" ? viewValue.id : viewValue)
    //
    //             scope.onSelectionChanged = ($item, $model) => {
    //                 ngModelCtrl.$setViewValue($item)
    //                 ngModelCtrl.$validate()
    //                 ngModelCtrl.$render()
    //                 if(angular.isFunction(scope.executeOnChange())){
    //                     scope.executeOnChange()($item)
    //                 }
    //             }
    //         }
    //     }
    // })
    // .component('taskProjectPickerMultiple', {
    //     require: {
    //         ngModelCtrl: "^ngModel"
    //     },
    //     bindings: {
    //         ngModel: '=',
    //         userProjectsFilter: '=',
    //         required: "=",
    //         modelType: '<',
    //         onChange: "&"
    //     },
    //     templateUrl: "app/task/task-project/picker-multiple.html",
    //     controller: function ($scope, $element, $attrs, TaskProject, uiSelectFix) {
    //         this.$onInit = () => {
    //             console.log('onInit', this.ngModel, this.selected)
    //         }
    //
    //         // let ctrl = this
    //         this.uiSelectFix = uiSelectFix
    //         console.log('start', this.ngModel, this.selected)
    //
    //         this.$onInit = () => {
    //             console.log('onInit', this.ngModel, this.selected)
    //             this.executeOnChange = this.onChange || angular.noop
    //             this.modelTypeR = this.modelType || "object"
    //             TaskProject.query().$promise.then(items => {
    //                 this.items = formatAndMap(items)
    //             })
    //         }
    //
    //         this.$onChanges = () => { //changes from parent controller
    //             this.selected = formatAndMap(this.ngModel)
    //             console.log('onChanges', this.ngModel, this.selected)
    //             this.ngChange()
    //         }
    //         this.ngChange = () => {
    //             console.log('ngChange', this.ngModel, this.selected)
    //             this.ngModel = this.selected
    //         }
    //
    //         function formatAndMap (items){
    //             if(!angular.isArray(items)){
    //                 return []
    //             }
    //             return items
    //                 .map(item => ({id: item.id, name: item.name}))
    //                 .sort((a, b) => a.name > b.name ? 1 : -1)
    //         }
    //     }
    // })
